import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();
export const ASSET_PREFIX = publicRuntimeConfig.ASSETS_ENDPOINT;

export const ENVIRONMENT =
  publicRuntimeConfig.DAYMADE_ENV || publicRuntimeConfig.ENVIRONMENT;
export const runningInProduction = ENVIRONMENT === 'production';
export const APP_ENDPOINT =
  ENVIRONMENT === 'production'
    ? 'www.daymade.co.uk'
    : ENVIRONMENT === 'staging'
      ? 'drip.daymade.co.uk'
      : 'localhost:8443';
export const MAINTENANCE_MODE = publicRuntimeConfig.MAINTENANCE_MODE === '1';

export const runningLocally = ENVIRONMENT === 'local';

export const colors = {
  primaryBrandGray: '#4A4A4A',
  primaryBrandGrayPressed: '#2A2A2A',
  inputGray: '#A6A6A6',
  background: '#F8FAFF',
  primaryCta: '#FF6731',
  primaryCtaPressed: '#D1562A',
  footerBackground: '#F6F6F6',
  brand: {
    neon: '#59FEDE',
    pastel: '#84F3DD',
    shadow: '#00A1FF',
  },
  daily: {
    neon: '#D81DA6',
    pastel: '#FB9DF9',
    faint: '#F7D1F7',
  },
  trees: {
    primary: '#86FE00',
    neon: '#B8E986',
    pastel: '#7ED32185',
    shadow: '#417505',
  },
  icelandRaffle: {
    primary: '#FA6C68',
    pressed: '#D55C58',
  },
  green: {
    sectionBackground: '#90F6DF linear-gradient(#C5FAF1, #96F5DF)',
    underlineColour: '#68FADE',
  },
  orange: {
    sectionBackground: '#90F6DF linear-gradient(#FCD0A9, #FBB87D)',
    underlineColour: '#FFB780',
  },
  pink: {
    sectionBackground: '#90F6DF linear-gradient(#FDD9FE, #FEAAFF)',
    underlineColour: '#FF82CD',
  },
};

export const SkeletonWhite = '#FFF';
export const SkeletonGrey = '#F6F6F6';

// The width at which a burger menu will be displayed (instead of the regular full-width header bar).
export const burgerMenuBreakpoint = '710px';
export const contentMaxWidth = '1000px';

export const SUBSCRIPTION_DISCOUNT_PERCENTAGE = 10;

export const FACEBOOK_APP_ID = publicRuntimeConfig.NEXT_PUBLIC_FACEBOOK_APP_ID;

export const GOOGLE_CLIENT_ID =
  publicRuntimeConfig.NEXT_PUBLIC_GOOGLE_CLIENT_ID;

export const Cta = {
  NON_SUBSCRIBER: {
    label: 'Enter now',
    url: '/choose-your-plan',
  },
  FREEMIUM: {
    label: 'Go Premium',
    url: '/account/subscriptions/upgrade',
  },
  LITE: {
    label: 'Go Premium',
    url: '/account/subscriptions/upgrade',
  },
  PREMIUM: null,
};

/** This name is misleading. It is the Draw Type Plan Code, not the subscription's status */
export const SubscriberStatus = {
  PREMIUM: 'PREMIUM',
  LITE: 'LITE',
  FREEMIUM: 'FREEMIUM',
  NON_SUBSCRIBER: 'NON_SUBSCRIBER',
} as const;

export const useHalloweenLogos = () => {
  // Use Halloween logos for the week leading up to Halloween
  const now = new Date();
  const currentYear = now.getFullYear();
  return (
    now > new Date(`${currentYear}-10-26 00:00:00+00`) &&
    now < new Date(`${currentYear}-11-01 12:00:00+00`)
  );
};

export const useChristmasLogos = () => {
  // Use Christmas logos during december
  const now = new Date();
  const currentYear = now.getFullYear();
  return (
    now > new Date(`${currentYear}-12-01 00:00:00+00`) &&
    now < new Date(`${currentYear}-12-26 12:00:00+00`)
  );
};

export const DrawDays = {
  TUESDAY: 'TUESDAY',
  FRIDAY: 'FRIDAY',
  BOTH: 'BOTH',
};

export const PaymentSchedule = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
};

export const BundleRequirementsCode = {
  NONE: 'NONE',
  SUBSCRIPTION: 'SUBSCRIPTION', // Premium
  LITE_SUBSCRIPTION: 'LITE_SUBSCRIPTION',
  FREE_SUBSCRIPTION: 'FREE_SUBSCRIPTION',
  MONTHLY_SUBSCRIPTION: 'MONTHLY_SUBSCRIPTION', // Premium
  MONTHLY_LITE_SUBSCRIPTION: 'MONTHLY_LITE_SUBSCRIPTION',
  GIFT_CARD: 'GIFT_CARD',
  GIFT_CARD_WEGIFT: 'GIFT_CARD_WEGIFT',
};

export const WEEKS_PER_MONTH = 4;

export const snoozeDurations = [1, 2, 3, 4];

// Identify DAYMADE team members by their email address
export const isInternalEmailAdress = (emailAddress?: string) => {
  if (!emailAddress) return false;

  return (
    emailAddress.endsWith('@daymade.co.uk') ||
    emailAddress.endsWith('@triphunters.co.uk')
  );
};

export const PRIZE_NUMBERS = {
  PREMIUM: '400+',
  LITE: '350+',
};
